//@ts-check
import useFormContext from '../context/useFormContext';
import fieldsHelper from '../utils/fieldsHelper';
import contextBinding from './contextBinding';
import helpers from './helpers';
import ACTIONS from '../logic/actions';
/**
 * @param {import('../logic/types').EcrionFormRepeatingField} repeatingField
 * @param {import('./types').useBindingHookDataType} bindingData
 * @param {import('../logic/types').EcrionFormState} state
 */

var hasDefaultRepeatingItem = function hasDefaultRepeatingItem(repeatingField, bindingData, state) {
  var repeatingFieldData = state.data[repeatingField.id];
  if (!repeatingFieldData || repeatingFieldData.length === 0) return true; // there are more than one repeating item, so there's no default data

  if (repeatingFieldData.length > 1) return false; // if data is different than '0', means someone add and remove an item

  if (repeatingFieldData[0] !== 0) return false;
  var repeatingFieldSuffix = fieldsHelper.findContextSuffixFromIds(repeatingField.id, repeatingField.originalId);
  var hasDefaultData = true;
  bindingData.binding.fields.forEach(function (field) {
    var fieldId = field.fieldId + repeatingFieldSuffix + '_0';
    if (state.data[fieldId]) hasDefaultData = false;
  });
  return hasDefaultData;
};
/**
 * @param {import('../logic/types').EcrionFormRepeatingField} repeatingField
 * @param {import('./types').useBindingHookDataType} bindingData
 * @param {import('./types').ApplyLookupValueType} applyValue
 * @param {import('../logic/types').EcrionFormState} state
 * @returns {{append:boolean, values:Array<number>}}
 */


var getNewRepeatingData = function getNewRepeatingData(repeatingField, bindingData, applyValue, state) {
  if (hasDefaultRepeatingItem(repeatingField, bindingData, state)) {
    return {
      append: false,
      values: Object.keys(applyValue).map(function (v, index) {
        return index;
      })
    };
  }

  var repeatingFieldData = state.data[repeatingField.id];
  var lastValue = repeatingFieldData[repeatingFieldData.length - 1];
  var values = Object.keys(applyValue).map(function (v, index) {
    return index + lastValue + 1;
  });
  return {
    append: true,
    values: values
  };
};
/**
 * @param {import('./types').useBindingHookDataType} binding
 * @return {number}
 */


var getChildCount = function getChildCount(binding) {
  if (!binding.children || !binding.children.length) return 1;
  var count = 1;
  binding.children.forEach(function (b) {
    return count += getChildCount(b);
  });
  return count;
};
/**
 * @param {string} repeatingFieldId
 * @param {string} originalRepeatingFieldId
 * @param {import('./types').useBindingHookDataType} bindingData
 * @param {Array<import('./types').ApplyLookupValueType>} applyValues
 * @param {number} applyValuesIndex
 * @param {import("../logic/types").EcrionFormState} state
 * @param {(any) => any} dispatch
 */


var applyRepeatingBinding = function applyRepeatingBinding(repeatingFieldId, originalRepeatingFieldId, bindingData, applyValues, applyValuesIndex, state, dispatch) {
  var repeatingField = state.fields[repeatingFieldId] || state.fields[originalRepeatingFieldId];
  if (repeatingField.type !== 'repeating') return;
  var repeatingFieldData = state.data[repeatingFieldId];
  var repeatingFieldSuffix = fieldsHelper.findContextSuffixFromIds(repeatingFieldId, originalRepeatingFieldId);
  var repeatingData = getNewRepeatingData(repeatingField, bindingData, applyValues[applyValuesIndex], state);
  var append = repeatingData.append,
      repeatingValues = repeatingData.values;
  var newRepeatingValues = append ? repeatingFieldData.concat(repeatingValues) : repeatingValues;

  if (repeatingValues && repeatingValues.length > 0) {
    dispatch({
      type: ACTIONS.SET_REPEATING_FIELD_VALUE,
      payload: {
        fieldId: repeatingFieldId,
        value: newRepeatingValues
      }
    });
    dispatch({
      type: ACTIONS.UPDATE_VISIBILITY,
      payload: [repeatingFieldId]
    });
  }

  var applyValue = applyValues[applyValuesIndex];
  Object.keys(applyValue).map(function (id, idx) {
    var _applyValue$id = applyValue[id],
        context = _applyValue$id.context,
        values = _applyValue$id.values;
    var fieldValues = {};
    bindingData.binding.fields.map(function (val, index) {
      fieldValues[val.fieldId + repeatingFieldSuffix + '_' + repeatingValues[idx]] = values[index];
    }); // contextBinding.linkContext(fieldId, context, data.fieldsBinding.params, state, dispatch);

    dispatch({
      type: ACTIONS.SET_FIELDS_VALUES,
      payload: fieldValues
    });
  });
  var repeatingIdx = 0;
  bindingData.children.forEach(function (childBinding) {
    var childField = state.fields[childBinding.fieldId];
    if (!childField || childField.type !== 'repeating') return;
    Object.keys(applyValue).map(function (id, idx) {
      var childRepeatingId = childField.id + repeatingFieldSuffix + '_' + repeatingValues[idx];
      var newApplyValuesIdx = applyValuesIndex + repeatingIdx + 1;
      applyRepeatingBinding(childRepeatingId, childField.id, childBinding, applyValues, newApplyValuesIdx, state, dispatch);
    });
    repeatingIdx += getChildCount(childBinding);
  });
};
/**
 * @param {string} repeatingFieldId
 * @param {import('./types').useBindingHookDataType} bindingData
 * @param {Array<import('./types').ApplyLookupValueType>} applyValues
 * @param {import("../logic/types").EcrionFormState} state
 * @param {(any) => any} dispatch
 */


var apply = function apply(repeatingFieldId, bindingData, applyValues, state, dispatch) {
  applyRepeatingBinding(repeatingFieldId, state.fields[repeatingFieldId].originalId, bindingData, applyValues, 0, state, dispatch); // trigger a new form relayout after all fields where completed

  dispatch({
    type: ACTIONS.FORM_DATA_CHANGED
  });
};

export default {
  apply: apply
};